import { _ep0, _mw0, command } from "../commandBuilder";
import { CreateAttendeeUser$ } from "../schemas/schemas_0";
export class CreateAttendeeUserCommand extends command(_ep0, _mw0, "CreateAttendeeUser", CreateAttendeeUser$) {
}
